import { NgModule } from '@angular/core';
import { DeeplinkService } from './services/deeplink.service';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';
import { DEEP_LINK_STATES } from './deeplink.state';

@NgModule({
    imports: [
        UIRouterUpgradeModule.forChild({ states: DEEP_LINK_STATES }),
    ],
    providers: [
        DeeplinkService,
    ],
})
export class DeeplinkModule {}
